<template>
  <div class="dimission">
    <div class="flex-center icon">
      <van-icon name="warning" size="38" color="var(--c4)" />
    </div>
    <div class="flex-center title1">是否确认员工 {{name}} 离职？</div>
    <div class="flex-center title2" v-if="!canDimission">
      此员工存在以下正在管理的信息，请重新分配后<br />再操作员工离职
    </div>
    <div class="flex-center title2" v-else>
      离职后，此员工将不能再登录使用云校、小竹<br />通、脸到等校管家相关产品
    </div>

    <div class="wrapper" v-if="!canDimission">
      <div class="item flex-between" v-if="count.waitClueCount">
        <div class="left">
          <div class="main">意向确认</div>
          <div class="desc">{{ count.waitClueCount }}条未确认意向的 跟进人 为该员工</div>
        </div>
        <div class="right flex-center" @click="toAssign1">
          <span class="tlc">去分配</span>
          <van-icon name="arrow" size="16" color="var(--g5)"></van-icon>
        </div>
      </div>

      <div class="item flex-between" v-if="count.followStudentCount">
        <div class="left">
          <div class="main">意向学员</div>
          <div class="desc">{{ count.followStudentCount }}名学员的 跟进人 为该员工</div>
        </div>
        <div class="right flex-center" @click="toAssign2">
          <span class="tlc">去分配</span>
          <van-icon name="arrow" size="16" color="var(--g5)"></van-icon>
        </div>
      </div>

      <div class="item flex-between" v-if="count.waitClassCount">
        <div class="left">
          <div class="main">班级管理</div>
          <div class="desc">{{ count.waitClassCount }}个未结班班级的 上课老师或助教 为该员工</div>
        </div>
        <div class="right flex-center" @click="toAssign3">
          <span class="tlc">去分配</span>
          <van-icon name="arrow" size="16" color="var(--g5)"></van-icon>
        </div>
      </div>

      <!-- <div class="item flex-between" v-if="count.waitAssistantClassCount">
        <div class="left">
          <div class="main">班级管理</div>
          <div class="desc">{{ count.waitAssistantClassCount }}个未结班班级的 助教 为该员工</div>
        </div>
        <div class="right flex-center" @click="toAssign4">
          <span class="tlc">去分配</span>
          <van-icon name="arrow" size="16" color="var(--g5)"></van-icon>
        </div>
      </div> -->

      <div class="item flex-between" v-if="count.waitRollCallCount">
        <div class="left">
          <div class="main">课表点名</div>
          <div class="desc">{{ count.waitRollCallCount }}节未点名排课的 上课老师 为该员工</div>
        </div>
        <div class="right flex-center" @click="toAssign5">
          <span class="tlc">去分配</span>
          <van-icon name="arrow" size="16" color="var(--g5)"></van-icon>
        </div>
      </div>

      <div class="item flex-between" v-if="count.waitAssistantRollCallCount">
        <div class="left">
          <div class="main">课表点名</div>
          <div class="desc">{{ count.waitAssistantRollCallCount }}节未点名排课的 助教 为该员工</div>
        </div>
        <div class="right flex-center" @click="toAssign6">
          <span class="tlc">去分配</span>
          <van-icon name="arrow" size="16" color="var(--g5)"></van-icon>
        </div>
      </div>
    </div>
    <div v-else style="flex: 1 1 auto"></div>
    <pageFooterBtn btnText="取消" @click="$router.back()" btnType="default" v-if="!canDimission" />
    <pageFooterBtn multipleBtns v-else>
      <van-button type="default" square round block @click.stop="$router.back()">取消</van-button>
      <van-button type="primary" square round block @click.stop="lizhi">确认离职</van-button>
    </pageFooterBtn>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
export default {
  components: { pageFooterBtn },
  data() {
    return {
      name: this.$route.query.name,
      count: {
        waitClassCount: 0,
        waitAssistantClassCount: 0,
        waitClueCount: 0,
        waitRollCallCount: 0,
        followStudentCount: 0,
        eduStudentCount: 0,
        waitAssistantRollCallCount: 0,
      },
    };
  },
  computed: {
    canDimission() {
      let {
        waitAssistantClassCount,
        waitClassCount,
        waitClueCount,
        waitRollCallCount,
        followStudentCount,
        waitAssistantRollCallCount,
      } = this.count;
      return (
        waitAssistantClassCount,
        waitClassCount +
          waitClueCount +
          waitRollCallCount +
          followStudentCount +
          waitAssistantRollCallCount ==
          0
      );
    },
  },
  methods: {
    async lizhi() {
      this.showLoading();
      const res = await this.$api.leaveOffice({
        teacherId: +this.$route.params.id
      });
      vant.Toast.clear();
      if (res.code === 200){
        vant.Toast.success('离职成功');
        setTimeout(() => {
          app.vue.$emit('people-list-refresh');
          this.$router.back();
        }, 300);
      } else if (res.code === 810000013){      
        vant.Dialog.alert({
          title: `提示`,
          message: `此员工存在以下正在管理的信息，请重新分配后<br />再操作员工离职`,
          allowHtml: true,
          confirmButtonText: '我知道了',
          confirmButtonColor: 'var(--c1)',
        });
        this.getData();
      }
    },
    async getData() {
      this.showLoading();
      const res1 = await this.$api.getTeacherWaitThings({
        teacherId: this.$route.params.id,
      });
      if (res1.data) {
        Object.assign(this.count, res1.data);
      }
      vant.Toast.clear();
    },
    toAssign1() {
      this.$router.push({
        name: 'allClue',
        params: {
          defineParams: true,
          followTeacherIds: [+this.$route.params.id],
          followTeacherList: [
            {
              id: +this.$route.params.id,
              name: this.name,
            },
          ],
        },
      });
    },
    toAssign2() {
      this.$router.push({
        name: 'intentionStudent',
        params: {
          defineParams: true,
          followTeacherIds: [+this.$route.params.id],
          followTeacherList: [
            {
              id: +this.$route.params.id,
              name: this.name,
            },
          ],
        },
      });
    },
    toAssign3() {
      this.$router.push({
        name: 'baseClassList',
        params: {
          defineParams: true,
          teacherIds: [+this.$route.params.id],
          teacherList: [
            {
              id: +this.$route.params.id,
              name: this.name,
            },
          ],
        },
      });
    },
    toAssign4() {
      this.$router.push({
        name: 'baseClassList',
        params: {
          defineParams: true,
          assistantIds: [+this.$route.params.id],
          assistantList: [
            {
              id: +this.$route.params.id,
              name: this.name,
            },
          ],
        },
      });
    },
    toAssign5() {
      this.$router.push({
        name: 'paikeList',
        query: {
          onlyMy: 0,
        },
        params: {
          defineParams: true,
          teacherIds: [+this.$route.params.id],
          teacherList: [
            {
              id: +this.$route.params.id,
              name: this.name,
            },
          ],
        },
      });
    },
    toAssign6() {
      this.$router.push({
        name: 'paikeList',
        query: {
          onlyMy: 0,
        },
        params: {
          defineParams: true,
          assistantIds: [+this.$route.params.id],
          assistantList: [
            {
              id: +this.$route.params.id,
              name: this.name,
            },
          ],
        },
      });
    },
  },
  vxshow() {
    this.getData();
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.dimission {
  display: flex;
  flex-direction: column;
  .icon {
    margin-top: 30px;
    margin-bottom: 16px;
  }
  .title1 {
    font-size: var(--fs-ex1);
    line-height: var(--lh-ex1);
    color: var(--g8);
    margin-bottom: 8px;
    font-weight: bold;
  }
  .title2 {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    color: var(--g6);
  }
  .wrapper {
    flex: 1 1 auto;
    background: var(--white);
    border-radius: 12px;
    padding: 12px 0;
    margin: 20px 16px;
    .item {
      padding: 12px 16px;
      .left {
        text-align: left;
        .main {
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g8);
          margin-bottom: 4px;
        }
        .desc {
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--g6);
        }
      }
      .right {
        .tlc {
          color: var(--c1);
          margin-right: 2px;
        }
      }
    }
  }
}
</style>